var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { TipoDocumentoEnum, TipoDocumentoOptions } from '../../../model/enums/TipoDocumentoEnum';
import { Format } from '../../../util/Format';
import { ShowContent } from '../../../components/ShowContent';
import { GridView } from './GridView';
import { emptyBlocks, resolveCondition } from './CommonView';
import { SexoEnum } from '../../../model/enums/SexoEnum';
export var ConfrontanteView = function (_a) {
    var _b;
    var dados = _a.dados;
    var dadosConfrontante = useCallback(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var ocupante = dados === null || dados === void 0 ? void 0 : dados.ocupante;
        var ocupantePF = ocupante === null || ocupante === void 0 ? void 0 : ocupante.ocupantePF;
        var ocupantePJ = ocupante === null || ocupante === void 0 ? void 0 : ocupante.ocupantePJ;
        var informarSocPF = !!(ocupantePF === null || ocupantePF === void 0 ? void 0 : ocupantePF.nomeSocial);
        var informarSocRL = !!((_a = ocupantePJ === null || ocupantePJ === void 0 ? void 0 : ocupantePJ.representante) === null || _a === void 0 ? void 0 : _a.nomeSocial);
        var isPF = (ocupante === null || ocupante === void 0 ? void 0 : ocupante.tipoOcupante) === TipoDocumentoEnum.PF;
        var fields = [];
        var subFields = [];
        if (isPF) {
            fields = [
                {
                    label: 'CPF do Ocupante',
                    value: Format.cpf((_b = ocupante === null || ocupante === void 0 ? void 0 : ocupante.ocupantePF) === null || _b === void 0 ? void 0 : _b.cpf)
                },
                {
                    label: 'Nome do Ocupante',
                    value: (_c = ocupante === null || ocupante === void 0 ? void 0 : ocupante.ocupantePF) === null || _c === void 0 ? void 0 : _c.nome
                },
                {
                    label: "Informar Nome Social",
                    value: "".concat(informarSocPF),
                    type: 'check',
                },
                resolveCondition(informarSocPF, 'Nome Social do Ocupante', ocupantePF === null || ocupantePF === void 0 ? void 0 : ocupantePF.nomeSocial),
                {
                    label: 'Sexo',
                    value: ((ocupantePF === null || ocupantePF === void 0 ? void 0 : ocupantePF.sexo) ? SexoEnum.getDescricao(ocupantePF === null || ocupantePF === void 0 ? void 0 : ocupantePF.sexo) : '')
                },
            ];
            var conjuge = (_d = ocupante === null || ocupante === void 0 ? void 0 : ocupante.ocupantePF) === null || _d === void 0 ? void 0 : _d.conjuge;
            var semConj = !(conjuge === null || conjuge === void 0 ? void 0 : conjuge.cpf);
            subFields = __spreadArray(__spreadArray([
                {
                    label: 'Confrontante possui conjuge?',
                    value: (semConj ? 'Não' : 'Sim')
                }
            ], emptyBlocks(1, false), true), [
                (!semConj ? {
                    label: 'CPF do Conjuge Ocupante',
                    value: Format.cpf(conjuge === null || conjuge === void 0 ? void 0 : conjuge.cpf)
                } : {}),
                (!semConj ? {
                    label: 'Nome do Conjuge Ocupante',
                    value: conjuge === null || conjuge === void 0 ? void 0 : conjuge.nome
                } : {})
            ], false);
        }
        else {
            fields = [
                {
                    label: 'CNPJ do Confrontante',
                    value: Format.cnpj((_e = ocupante === null || ocupante === void 0 ? void 0 : ocupante.ocupantePJ) === null || _e === void 0 ? void 0 : _e.cnpj)
                },
                {
                    label: 'Razão Social do Confrontante',
                    value: (_f = ocupante === null || ocupante === void 0 ? void 0 : ocupante.ocupantePJ) === null || _f === void 0 ? void 0 : _f.razaoSocial
                }
            ];
            subFields = [
                {
                    label: 'CPF do Representante Legal do Confrontante',
                    value: Format.cpf((_h = (_g = ocupante === null || ocupante === void 0 ? void 0 : ocupante.ocupantePJ) === null || _g === void 0 ? void 0 : _g.representante) === null || _h === void 0 ? void 0 : _h.cpf)
                },
                {
                    label: 'Nome do Representante Legal do Confrontante',
                    value: (_k = (_j = ocupante === null || ocupante === void 0 ? void 0 : ocupante.ocupantePJ) === null || _j === void 0 ? void 0 : _j.representante) === null || _k === void 0 ? void 0 : _k.nome
                },
                {
                    label: "Informar Nome Social",
                    value: "".concat(informarSocRL),
                    type: 'check',
                },
                resolveCondition(informarSocRL, 'Nome Social do Representante Legal do Confrontante', ocupantePF === null || ocupantePF === void 0 ? void 0 : ocupantePF.nomeSocial),
                {
                    label: 'Sexo',
                    value: ((ocupantePF === null || ocupantePF === void 0 ? void 0 : ocupantePF.sexo) ? SexoEnum.getDescricao(ocupantePF === null || ocupantePF === void 0 ? void 0 : ocupantePF.sexo) : '')
                },
            ];
        }
        return __spreadArray(__spreadArray(__spreadArray([
            {
                label: 'Qual tipo de Pessoa?',
                value: ((ocupante === null || ocupante === void 0 ? void 0 : ocupante.tipoOcupante) ? TipoDocumentoOptions.getDescricao(ocupante === null || ocupante === void 0 ? void 0 : ocupante.tipoOcupante) : '')
            },
            {
                type: 'emptyBlock',
                fullWidth: true
            }
        ], fields, true), [
            {
                label: 'Denominação do Imóvel do Ocupante',
                value: ocupante === null || ocupante === void 0 ? void 0 : ocupante.denominacao,
                fullWidth: true
            }
        ], false), subFields, true);
    }, [dados === null || dados === void 0 ? void 0 : dados.ocupante]);
    var isNoKey = useCallback(function (obj) {
        var _a;
        return ((_a = Object.keys(obj)) === null || _a === void 0 ? void 0 : _a.length) === 0;
    }, []);
    return (_jsx(_Fragment, { children: (_b = dadosConfrontante()) === null || _b === void 0 ? void 0 : _b.map(function (option, index) { return (_jsx(ShowContent, __assign({ show: !isNoKey(option) }, { children: _jsx(GridView, { index: index, option: option }, "grid_field_".concat(index === null || index === void 0 ? void 0 : index.toString())) }), "field-".concat(index === null || index === void 0 ? void 0 : index.toString()))); }) }));
};
